import request from '../../shared/request'

export function getVendorsList() {
  return request('/vendor')
}

export function createNewVendor(payload) {
  return request(`/vendor/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateSavedVendor(payload) {
  return request(`/vendor/${payload.company_id}`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteVendor(payload) {
  return request(`/vendor/${payload.company_id}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

// notes
export function fetchVendorNote(payload) {
  return request(`/vendor/${payload.vendorId}/notes`)
}

export function createVendorNote(payload) {
  return request(`/vendor/${payload.vendorId}/notes`, {
    method: 'POST',
    body: payload,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function editVendorNote(payload) {
  return request(`/vendor/${payload.noteId}/notes`, {
    method: 'PUT',
    body: payload,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function deleteVendorNote(payload) {
  return request(`/vendor/${payload.noteId}/notes`, {
    method: 'DELETE',
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

// attachments
export function uploadVendorAttachments(payload) {
  return request(`/vendor/${payload.vendorId}/attachment`, {
    method: 'POST',
    body: payload.formData,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function getVendorAttachments(vendor_id) {
  return request(`/vendor/${vendor_id}/attachments/`)
}

export function updateAttachmentDescription(payload) {
  return request(`/vendor/${payload.attachmentId}/attachment`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteVendorAttachment(payload) {
  return request(`/vendor/${payload.attachmentId}/attachment/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/vendor.js